import { __rest, __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useFilter, useComboBox } from 'react-aria';
import { useComboBoxState } from 'react-stately';
import { useRef, useCallback } from 'react';
import clsx from 'clsx';
import { ListBox } from '../../base/listBox/ListBox.js';
import { Popover } from '../../base/popover/Popover.js';
import { Input } from '../input/Input.js';
import { useSetNativeValue } from '../../hooks/useSetNativeValue/useSetNativeValue.js';
import styles from './Autocomplete.module.scss.js';

var Autocomplete = function (_a) {
    var _b;
    var children = _a.children, items = _a.items, inputProps = _a.inputProps, size = _a.size, placeholder = _a.placeholder, isClearable = _a.isClearable, _c = _a.loadingState, loadingState = _c === void 0 ? 'idle' : _c, _d = _a.skipFilteringResults, skipFilteringResults = _d === void 0 ? false : _d, noResultsPlaceholder = _a.noResultsPlaceholder, _e = _a.disallowCustomValue, disallowCustomValue = _e === void 0 ? false : _e, _f = _a.offset, offset = _f === void 0 ? 0 : _f, onLoadMore = _a.onLoadMore, onSelectionChange = _a.onSelectionChange, props = __rest(_a, ["children", "items", "inputProps", "size", "placeholder", "isClearable", "loadingState", "skipFilteringResults", "noResultsPlaceholder", "disallowCustomValue", "offset", "onLoadMore", "onSelectionChange"]);
    var inputRef = useRef(null);
    var listBoxRef = useRef(null);
    var popoverRef = useRef(null);
    var contains = useFilter({ sensitivity: 'base' }).contains;
    var setNativeValue = useSetNativeValue();
    var onInputChange = useCallback(function (value) {
        var input = inputRef.current;
        setNativeValue(input, value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
    }, [setNativeValue]);
    var comboboxOptions = {
        placeholder: placeholder,
        items: items,
        label: props.label,
        inputValue: inputProps.value,
        onInputChange: onInputChange,
        children: children,
        onSelectionChange: onSelectionChange,
        onFocus: inputProps.onFocus,
        onBlur: inputProps.onBlur,
    };
    var state = useComboBoxState(__assign(__assign({}, comboboxOptions), { allowsEmptyCollection: !!noResultsPlaceholder, allowsCustomValue: !disallowCustomValue, defaultFilter: skipFilteringResults ? undefined : contains }));
    var _g = useComboBox(__assign(__assign({}, comboboxOptions), { inputRef: inputRef, listBoxRef: listBoxRef, popoverRef: popoverRef }), state), _h = _g.inputProps; _h.size; var value = _h.value; _h.onChange; var onFocus = _h.onFocus, onBlur = _h.onBlur, inputPropsValues = __rest(_h, ["size", "value", "onChange", "onFocus", "onBlur"]), listBoxProps = _g.listBoxProps, labelProps = _g.labelProps;
    return (jsxs(Fragment, { children: [jsx(Input, __assign({}, props, inputPropsValues, { labelId: inputPropsValues['aria-labelledby'], isClearable: isClearable, size: size, inputProps: {
                    value: value,
                    onChange: inputProps.onChange,
                    onFocus: onFocus,
                    onBlur: onBlur,
                }, ref: inputRef })), jsxs(Popover, __assign({ offset: offset, overlayRef: popoverRef, triggerRef: inputRef, isOpen: state.isOpen, onClose: state.close }, { children: [state.collection.size === 0 && !!noResultsPlaceholder && loadingState === 'idle' && (jsx("div", __assign({ className: clsx(styles.listboxWrapper, styles.noResults) }, { children: noResultsPlaceholder }))), state.collection.size > 0 && (jsx(ListBox, __assign({}, listBoxProps, { className: clsx(styles.listbox, (_b = {},
                            _b[styles.listboxWithPadding] = !!props.leftElement,
                            _b)), wrapperClassName: styles.listboxWrapper, state: state, "aria-labelledby": labelProps.id, listBoxRef: listBoxRef, size: size, loadingState: loadingState, onLoadMore: onLoadMore })))] }))] }));
};
Autocomplete.Item = ListBox.Item;

export { Autocomplete };
